import BaseApi, { API_VERSION, type ServerListRequest, cleanParams } from '@lumapps/base-api';

import type { ProviderListResponse } from '../types';

/**
 * Base API instance for providers.
 */
const providersApi = new BaseApi({ path: 'providers', version: API_VERSION.v2 });

export interface FetchProviderListFilters {
    /** label of providerType */
    providerTypes?: string[];
    /** name provider */
    name?: string;
    /** except providers */
    exceptProviders?: string[];
}

export interface FetchProviderListParams extends FetchProviderListFilters, ServerListRequest {}

/**
 * Get the provider list.
 *
 * @param {FetchProviderListParams} params
 * @param {string | undefined} fetchKey
 * @returns {ProviderListResponse}
 */
export const getProviderList = async (params: FetchProviderListParams, fetchKey?: string) => {
    const { data: provider } = await providersApi.get<ProviderListResponse>(
        '',
        {
            params: cleanParams({ ...params, providerTypes: params.providerTypes?.join(',') }),
        },
        undefined,
        fetchKey !== undefined,
        fetchKey,
    );

    return provider;
};

/**
 * Cancel the provider list
 *
 * @param {string} fetchKey
 */
export const cancelProviderList = (fetchKey: string): void => providersApi.cancel('', undefined, fetchKey);
